'use strict'

import shuffle from './shuffle'

/*
  Chromosome used in Genetic Aglorithm
*/
export default class Life {
  constructor (gene = 100) {
    this.gene = Array.isArray(gene) ? gene : this.rndGene(gene)
    while(this.gene[0] != 0) {
      var x = this.gene.shift()
      this.gene.push(x)
    }
    this.score = 0
  }

  rndGene (n) {
    return shuffle((new Array(n)).fill(0).map((_, idx) => idx))
  }

  setScore (v) {
    this.score = v
  }

  toString () {
    return this.gene.join('-')
  }
}
